export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/contact.31e36a4d-27b76d.svg";